import React from 'react';
import { Container } from 'reactstrap';
import AudioPage from './AudioPage';
import './App.css';
import SplashPage from './SplashPage';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      home: true,
      language: null,
    };

    this.chooseLanguage = this.chooseLanguage.bind(this);
  }

  chooseLanguage(language) {
    this.setState({
      home: false,
      language,
    });
  }

  render() {
    return (
      <Container fluid>
        {this.state.home
         ?
           <SplashPage chooseLanguage={this.chooseLanguage} />
         : <AudioPage
           chooseLanguage={this.chooseLanguage}
           language={this.state.language}
         />
        }
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js